// Modello IVA 2026, "Tabella generale dei codici di carica" — the codes the
// LIPE schema admits (comunicazioneIvp_2018_v1.xsd: 1-9, 11-15). Kept in step
// with backend models/client.IT_SIGNER_ROLES by a jest test.
export const IT_SIGNER_ROLES = ["", "1", "2", "3", "4", "5", "6", "7", "8", "9", "11", "12", "13", "14", "15"];
export const IT_SIGNER_ROLE_LABELS = {
  "1": "1 — Rappresentante legale, negoziale o di fatto, socio amministratore",
  "2": "2 — Rappresentante di minore, inabilitato o interdetto, amministratore di sostegno, curatore dell'eredità",
  "3": "3 — Curatore fallimentare / della liquidazione giudiziale",
  "4": "4 — Commissario liquidatore",
  "5": "5 — Custode o amministratore giudiziario, commissario giudiziale",
  "6": "6 — Rappresentante fiscale di soggetto non residente",
  "7": "7 — Erede",
  "8": "8 — Liquidatore (liquidazione volontaria)",
  "9": "9 — Soggetto che dichiara per il soggetto estinto (operazioni straordinarie)",
  "11": "11 — Soggetto esercente l'attività tutoria",
  "12": "12 — Liquidatore di ditta individuale (ante liquidazione)",
  "13": "13 — Amministratore di condominio",
  "14": "14 — Chi sottoscrive per una pubblica amministrazione",
  "15": "15 — Commissario liquidatore di una pubblica amministrazione",
};
